module.exports = __webpack_public_path__ + "static/media/gray-tl.546657d2.svg";